<template>
  <GrLayoutTemplate :openSideMenu="openSideMenu" :wideContainer="false">
    <template v-slot:top-navbar>
      <div class="col-7">
        <slot name="top-navbar-left"></slot>
      </div>

      <div class="col-5">
        <slot name="top-navbar-right"></slot>
      </div>
    </template>

    <template v-slot:side-bar>
      <slot name="side-bar"></slot>
    </template>

    <template v-slot:container>
      <div
        class="col-12 d-flex flex-column"
        style="min-height: calc(100vh - 40px)"
      >
        <slot name="container"></slot>
      </div>
    </template>
  </GrLayoutTemplate>
</template>

<script setup lang="ts">
import GrLayoutTemplate from "./GrLayoutTemplate.vue";
import { withDefaults, defineProps } from "vue";

type GrLayoutProps = {
  openSideMenu: boolean;
};

withDefaults(defineProps<GrLayoutProps>(), {
  openSideMenu: false
});
</script>
